import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthContext';
import { ErrorNote } from '../components/ui';

const DEMO_LOGINS = [
  { email: 'ops@snaphub.io', label: 'Operations' },
  { email: 'sme@verdefoods.example', label: 'Supplier — Verde Foods' },
  { email: 'payer@metromart.example', label: 'Payer — MetroMart' },
  { email: 'lender@meridian.example', label: 'Lender — Meridian' },
  { email: 'admin@snaphub.io', label: 'Administrator' },
];

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('ops@snaphub.io');
  const [password, setPassword] = useState('Accel!Demo2026');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="brand-name" style={{ fontSize: 26 }}>
          Accel
        </div>
        <div className="brand-tag" style={{ marginBottom: 22 }}>
          SnapHub Embedded Finance
        </div>

        <ErrorNote error={error} />

        <form onSubmit={submit}>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div style={{ marginTop: 22, borderTop: '1px solid var(--line)', paddingTop: 16 }}>
          <div className="ctx-label" style={{ marginBottom: 8 }}>
            Seeded accounts
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {DEMO_LOGINS.map((d) => (
              <button
                key={d.email}
                type="button"
                className="btn btn-ghost"
                style={{ fontSize: 11.5, padding: '5px 10px' }}
                onClick={() => setEmail(d.email)}
              >
                {d.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
